import { useMutation } from 'react-query';
import {
  deleteIntegrationsAsync,
  getAllIntegrationsByLicenseAsync,
} from '../../index';

export const useGetAllIntegrationsByLicenseAsync = () =>
  useMutation(getAllIntegrationsByLicenseAsync);

export const useDeleteIntegrationsAsync = () =>
  useMutation(deleteIntegrationsAsync);
